export default "__VITE_ASSET__B7KY$9tO__"